<annotated-control [field]="field">
  @for (value of values; track value; let last = $last) {
  <div class="inputs">
    @for (option of options; track option; let i = $index) {
    <div
      class="input input-{{ options[i].display_type }}"
      [class.input-group]="options[i].prefix || options[i].suffix"
    >
      @if (options[i].prefix) {
      <span class="input-group-text">{{ options[i].prefix }}</span>
      } @if (option.display_type === 'select' || option.display_type ===
      'select2') {
      <basic-select
        [id]="field.attributes.id"
        [value]="value[i]"
        (valueChange)="value[i] = $event; propagateValueChange()"
        [disabled]="disabled"
        [options]="option.items"
      ></basic-select>
      } @if (option.display_type === 'checkbox') {
      <input
        type="checkbox"
        [ngModel]="value[i]"
        [disabled]="disabled"
        (ngModelChange)="value[i] = $event; propagateValueChange()"
      />
      } @if (option.display_type === 'text' || option.display_type === 'number')
      {
      <input
        [type]="option.display_type"
        class="form-control"
        [ngModel]="value[i]"
        [disabled]="disabled"
        (ngModelChange)="value[i] = $event; propagateValueChange()"
      />
      } @if (option.display_type === 'textarea') {
      <textarea
        class="form-control"
        [ngModel]="value[i]"
        [disabled]="disabled"
        (ngModelChange)="value[i] = $event; propagateValueChange()"
      ></textarea>
      } @if (option.display_type === 'date') {
      <div>
        <input
          type="text"
          [ngModel]="value[i]"
          [disabled]="disabled"
          [matDatepicker]="datepicker"
          (focus)="datepicker.open()"
          (click)="datepicker.open()"
          (ngModelChange)="value[i] = $event; propagateValueChange()"
          class="form-control"
        />
        <mat-datepicker #datepicker (closed)="touch()"></mat-datepicker>
      </div>
      } @if (options[i].suffix) {
      <span class="input-group-text">{{ options[i].suffix }}</span>
      }
    </div>
    } @if (!disabled) {
    <array-field-controls
      [canRemove]="canRemove"
      [canAdd]="last && canAdd"
      (add)="addEmptyValue()"
      (remove)="removeValue(value)"
    ></array-field-controls>
    }
  </div>
  }
</annotated-control>
